import {
  PriceDetails,
  PackageThumbnail
} from "./package/package.model";

/* @ngInject */
export default class PriceService {
  public priceDetails: PriceDetails;

  constructor(private $sce, private $translate, private i18n) {}

  public getPriceInfo(packet: PackageThumbnail) {
    try {
      if(packet.priceDescription){
        this.priceDetails = JSON.parse(packet.priceDescription);
        
        if (
          this.priceDetails.pricePeriod &&
          this.priceDetails.pricePeriod === "monthly"
        ) {
          return "packet.monthly";
        } else if (this.priceDetails.pricePeriod === "yearly") {
          return "packet.yearly";
        } else if (this.priceDetails.pricePeriod === "none") {
          return "packet.none";
        } else return "packet.monthly";
     } else return"packet.monthly";
    } catch (error) {}

  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/price.service.ts